import { useMemo } from 'react'
import { camelizeKeys } from 'humps'
import { StringParam } from 'use-query-params'
import { useQueryParams } from 'utils/hooks'

interface ITrackConversionParams {
  eventSource?: string
  utmMedium?: string
  utmSource?: string
  utmContent?: string
}

const EMAIL_UTM_CONTENTS = [
  'dispatcher_created',
  'cm_created',
  'auto_historical',
  'dispatcher_truck_availability',
] as const

export const WATERFALL_EMAIL_UTM_PARAM = 'reserved_load_offer'

export type TEmailUtmContent = typeof EMAIL_UTM_CONTENTS[number]

const isEmailUtm = (val: any): val is TEmailUtmContent => {
  return EMAIL_UTM_CONTENTS.includes(val)
}

export const useTrackConversionParams = () => {
  const [notCamelizedParams] = useQueryParams<ITrackConversionParams>({
    eventSource: StringParam,
    utm_medium: StringParam,
    utm_source: StringParam,
    utm_content: StringParam,
  })

  const params = useMemo(() => camelizeKeys(notCamelizedParams), [
    notCamelizedParams,
  ]) as ITrackConversionParams
  const isEmail = useMemo(
    () =>
      params.eventSource === 'savedSearchEmail' &&
      params.utmMedium === 'email' &&
      isEmailUtm(params.utmContent),
    [params.eventSource, params.utmContent, params.utmMedium]
  )

  return {
    params,
    isEmail,
  }
}
